const reduceFromObjects = (array, field) =>
  array ? array.reduce((accum, curr) => (accum += curr[field]), 0) : 0;

export default reduceFromObjects;
